var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m12 17.2-4.15 2.5a.9.9 0 0 1-.575.15.97.97 0 0 1-.525-.2 1.2 1.2 0 0 1-.35-.437.87.87 0 0 1-.05-.588l1.1-4.725-3.675-3.175A.96.96 0 0 1 3.5 9.65q.1-.274.3-.45.2-.175.55-.225L9.2 8.55l1.875-4.45q.125-.3.388-.45T12 3.5t.537.15.388.45L14.8 8.55l4.85.425q.35.05.55.225t.3.45q.1.274.038.563a.96.96 0 0 1-.313.512L16.55 13.9l1.1 4.725a.87.87 0 0 1-.05.587q-.125.263-.35.438a.97.97 0 0 1-.525.2.9.9 0 0 1-.575-.15z"
})));
export default SvgStarFilled;